import { Dashboard } from "./dashboard/Dashboard";
import { Invoices } from "./invoices/Invoices";
import { Subscriptions } from "./subscriptions/Subscriptions";
import { PaymentMethods } from "./payment-methods/PaymentMethods";
import { Page } from "@/config/models";

export const pageComponents: Record<Page, React.ComponentType<any>> = {
    Dashboard: Dashboard,
    Subscriptions: Subscriptions,
    Invoices: Invoices,
    PaymentMethods: PaymentMethods
}